import { useState, useRef } from 'react';

const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz#$%&@!?';

const ScrambleText = ({ text, tag: Tag = 'h2', className }) => {
  const [display, setDisplay] = useState(text);
  const frameRef = useRef(null);
  const iterRef = useRef(0);

  const scramble = () => {
    cancelAnimationFrame(frameRef.current);
    iterRef.current = 0;
    const step = () => {
      setDisplay(
        text.split('').map((char, i) => {
          if (char === ' ') return ' ';
          if (i < iterRef.current) return char;
          return CHARS[Math.floor(Math.random() * CHARS.length)];
        }).join('')
      );
      iterRef.current += 0.4;
      if (iterRef.current < text.length) {
        frameRef.current = requestAnimationFrame(step);
      } else {
        setDisplay(text);
      }
    };
    frameRef.current = requestAnimationFrame(step);
  };

  return (
    <Tag className={className} onMouseEnter={scramble} style={{ cursor: 'default' }}>
      {display}
    </Tag>
  );
};

export default ScrambleText;
